import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const ArrowUpIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "arrow-up",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [/* @__PURE__ */ jsx("path", {
			d: "M7 11L12.5 5.5L18 11",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		}), /* @__PURE__ */ jsx("path", {
			d: "M12.5 5.5V20",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})]
	});
});
export { ArrowUpIcon, ArrowUpIcon as default };

//# sourceMappingURL=ArrowUp.js.map